var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_741_13888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2105 16.7894L32.4211 15.3684L16.7894 16.7894L15.3682 31.0001L16.7892 45.2107L30.9998 46.987L45.2105 45.2107L46.6315 30.645L45.2105 16.7894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6196 38.837C21.5574 38.1194 20.8219 37.0715 20.4204 35.6859L22.886 34.6698C23.1099 35.5225 23.5006 36.1832 24.0584 36.6522C24.6127 37.1212 25.2877 37.352 26.0764 37.352C26.8829 37.352 27.5757 37.1069 28.1546 36.6165C28.7334 36.1262 29.025 35.5009 29.025 34.7444C29.025 33.97 28.7194 33.3374 28.1084 32.8473C27.4974 32.3573 26.73 32.1119 25.8134 32.1119H24.3889V29.6713H25.6676C26.4563 29.6713 27.1207 29.4583 27.6607 29.032C28.2007 28.6056 28.4707 28.023 28.4707 27.2805C28.4707 26.6198 28.2291 26.0938 27.7461 25.6996C27.263 25.3054 26.6517 25.1064 25.9092 25.1064C25.1846 25.1064 24.6089 25.2984 24.1826 25.6856C23.7563 26.0728 23.4471 26.5488 23.2519 27.1101L20.8114 26.0941C21.1346 25.1775 21.728 24.3675 22.5982 23.6676C23.4687 22.9678 24.5806 22.616 25.9306 22.616C26.9288 22.616 27.8276 22.8079 28.6236 23.1951C29.4192 23.5823 30.0446 24.1188 30.4957 24.8008C30.9469 25.4863 31.1707 26.2539 31.1707 27.1063C31.1707 27.9768 30.9612 28.712 30.5419 29.316C30.1226 29.92 29.6074 30.3817 28.9964 30.7052V30.8507C29.8029 31.1882 30.4601 31.7034 30.9788 32.3962C31.4939 33.089 31.7531 33.9168 31.7531 34.8831C31.7531 35.8495 31.508 36.7127 31.0176 37.4695C30.5273 38.2263 29.8488 38.823 28.9891 39.2563C28.1259 39.6897 27.1561 39.91 26.0796 39.91C24.8328 39.9135 23.6817 39.5547 22.6196 38.837Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7501 26.602L35.0571 28.5595L33.7036 26.5062L38.5601 23.0032H40.4218V39.5264H37.7501V26.602Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2107 58L58 45.2107L51.6053 42.3687L45.2107 45.2107L42.3687 51.6053L45.2107 58Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9473 51.6054L16.7893 58H45.2103V45.2107H16.7893L13.9473 51.6054Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26303 4C5.90782 4 4 5.90782 4 8.26303V45.2104L10.3947 48.0524L16.7894 45.2104V16.7894H45.2104L48.0524 10.3947L45.2106 4H8.26303Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 45.2107V53.737C4 56.0925 5.90782 58 8.26303 58H16.7894V45.2107H4Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2104 16.7894V45.2104H57.9998V16.7894L51.6051 13.9474L45.2104 16.7894Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9998 16.7894V8.26303C57.9998 5.90755 56.092 4 53.7368 4H45.2104V16.7894H57.9998Z",
    fill: "#1967D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_741_13888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLogo);
export default __webpack_public_path__ + "static/media/calendarLogo.4e1bb1634eb13eeaf8b7b77d24645616.svg";
export { ForwardRef as ReactComponent };